import {createSelector} from 'reselect'
import {selectTaskManagement} from '../selectors'
import {getNextWorkflowStatusesIsLoaded, getTaskCustomFieldsMap, getViewMode} from "../common/selectors"
import {TaskManagementViewMode, TaskSortBy, TaskTableConfigurableColumns} from "../constants"
import {Feature, isEnabled} from "../../features/index"
import {getCustomers, getProjects} from "../../entities/selectors"
import {arrayToSet} from "../../atUtils"
import TaskManagementStore from '../TaskManagementStore'
import {isBTYEnabled, isESTEnabled} from '../../features/selectors'
import { selectTaskCustomFieldsIsLoaded } from '../../customFields/selectors'

const getTaskTableState = (state) => selectTaskManagement(state).taskTable

export const getColumnsOrder = (state) => getTaskTableState(state).columnsOrder

export const getShownColumns = (state) => getTaskTableState(state).columnsShown

export const getIsSummaryRowShown = (state) => getTaskTableState(state).isSummaryRowShown
export const getSummaryRow = (state) => getTaskTableState(state).summaryRow

export const getConfigurableTableColumns = createSelector(
    isESTEnabled,
    isBTYEnabled,
    getTaskCustomFieldsMap,
    (isESTEnabled, isBTYEnabled, customFieldsMap) => {
        const estimateRelatedColumns = [
            TaskTableConfigurableColumns.ESTIMATE,
            TaskTableConfigurableColumns.VARIANCE_MAN_HOURS,
            TaskTableConfigurableColumns.VARIANCE_PERCENTS,
            TaskTableConfigurableColumns.VARIANCE_PROGRESS_BAR,
        ]

        const predefined = Object.keys(TaskTableConfigurableColumns)
                                 .filter((column) => !((estimateRelatedColumns.includes(column) && !isESTEnabled) ||
                                                       (column === TaskTableConfigurableColumns.TYPE_OF_WORK && !isBTYEnabled)))
        Object.values(customFieldsMap).map(cf => cf.fieldName).forEach(column => {
            predefined.push(column)
        })
        return predefined
    }
)

export const getOrderedColumns = createSelector(
    getConfigurableTableColumns,
    getColumnsOrder,
    (columns, order) => {
        return columns.slice().sort((c1, c2) => {
            return order.indexOf(c1) - order.indexOf(c2)
        })
    }
)

export const getShownColumnsWithOrder = createSelector(
    getOrderedColumns,
    getShownColumns,
    (columns, shown) => {
        const shownSet = arrayToSet(shown)
        return columns.filter((column) => !!shownSet[column])
    }
)

export const getShownColumnsWithOrderForCsv = createSelector(
    getShownColumnsWithOrder,
    (columns) => {
        return columns.filter(column => column !== TaskSortBy.VARIANCE_PROGRESS_BAR)
    }
)

export const getTasksSorting = createSelector(
    getTaskTableState,
    (taskTable) => {
        const sorting = taskTable.sorting
        if (isEnabled(Feature.TWS) && sorting.by === TaskSortBy.STATUS) {
            return {
                ...sorting,
                by: TaskSortBy.WORKFLOW_STATUS
            }
        }

        if (!isEnabled(Feature.TWS) && sorting.by === TaskSortBy.WORKFLOW_STATUS) {
            return {
                ...sorting,
                by: TaskSortBy.STATUS
            }
        }

        return sorting
    }
)

export const isInitialDataLoaded = createSelector(
    selectTaskCustomFieldsIsLoaded,
    getNextWorkflowStatusesIsLoaded,
    (isTaskCustomFieldsLoaded, isNextWorkflowStatusesLoaded) => isTaskCustomFieldsLoaded && isNextWorkflowStatusesLoaded
)

export const isLoaded = state => getTaskTableState(state).isLoaded

export const isSummaryRowLoaded = state => getTaskTableState(state).isSummaryRowLoaded

export const isNeedToReloadTasks = createSelector(
    getViewMode,
    isLoaded,
    isInitialDataLoaded,
    (viewMode, isLoaded, isInitialDataLoaded) => viewMode === TaskManagementViewMode.TABLE && isLoaded === false && isInitialDataLoaded
)

export const getArchivedProjectIds = createSelector(
    getProjects,
    (projects) => arrayToSet(Object.values(projects).filter(p => p.archived).map(p => p.id))
)

export const getArchivedCustomerIds = createSelector(
    getCustomers,
    (customers) => arrayToSet(Object.values(customers).filter(c => c.archived).map(c => c.id))
)

/**
 * @Deprecated but used in many places
 */
export const getVisibleTableTaskIds = () => TaskManagementStore.getTaskIds()

/**
 * Like `getVisibleTableTaskIds` but used only for SelectionController
 */
export const getLoadedTaskIds = createSelector(
    getTaskTableState,
    (taskTableState) => taskTableState.loadedTaskIds
)

export const thereAreTableTasks = createSelector(
    getLoadedTaskIds,
    (taskIds) => taskIds.length !== 0
)



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/selectors.js